export const topContent: HTMLElement | null = document.querySelector('[data-first-content]');

export const topAside: HTMLElement | null = document.querySelector('[data-first-content] > aside');

export const topBanner: HTMLElement | null = topAside
  ? topAside.querySelector('.sidebar-content--top')
  : null;

export const adPositionDesktop: HTMLElement | null = topBanner
  ? topBanner.querySelector('.ad-position--desktop')
  : null;

export const miniplayer: HTMLElement | null = document.querySelector('[data-miniplayer]');

export const bottomContent: HTMLElement | null = document.querySelector('.main--second-content');

export const bottomAside: HTMLElement | null = document.querySelector(
  '.main--second-content > aside'
);

export const repeaterAddSelector = 'button[data-sidebar-recount]';

// Article detail page elements
export const articleMainContent: HTMLElement | null = document.querySelector(
  '[data-article-main-content]'
);

export const articleSecondaryContent: HTMLElement | null = document.querySelector(
  '[data-article-secondary-content]'
);
